import {
    Stack, Box, LinearProgress,
    Radio, FormControlLabel, Icon, FormLabel
} from '@mui/material'

import {useEffect, useRef, useState} from 'react'

export const Stepper = (props) => {
    const [steps, setStep] = useState([])

    const i = useRef(0)

    useEffect(() => { setStep(props.items) }, [props.items])

    return (
        <Stack spacing={1} direction={'row'} justifyContent={'center'} sx={{mt: 2, ...props.sx}}>
            {steps && steps.length > 0 && steps.map((item, index) => {
                i.current++
                return (
                    <Box sx={{width: '100%'}} key={item.id}>
                        <Stack direction={'column'} justifyContent={'center'}>
                            <LinearProgress
                                variant={'determinate'}
                                value={100}
                                color={(item.selected) ? 'primary' : 'secondary'}
                                sx={{borderRadius: 0, minHeight: '4px'}}
                            />
                            <FormControlLabel
                                control={<Radio disabled checked={item.completed} checkedIcon={(<Icon sx={{fontVariationSettings: "'FILL' 1"}}>check_circle</Icon>)}/>}
                                label={item.label}
                                componentsProps={{typography: {variant: 'body2'}}} />
                            <FormLabel sx={{marginLeft: '27px', marginTop: '-10px'}}>Step {index + 1}</FormLabel>
                        </Stack>
                    </Box>
                )
            })}
        </Stack>
    )
}

export default Stepper